export default "__VITE_ASSET__2Hqyv66J__"